import { useEffect, useState } from "react";
import { Car } from "lucide-react";
import { ServiceCard } from "../components/ServiceCard";
import { useLang } from "../context/LanguageContext";
import { api } from "../lib/api";

export default function Services() {
  const { t } = useLang();
  const [services, setServices] = useState([]);

  useEffect(() => {
    api.get("/services").then((r) => setServices(r.data)).catch(() => {});
  }, []);

  return (
    <div data-testid="services-page" className="max-w-7xl mx-auto px-4 sm:px-6 py-16">
      <h1 className="text-4xl sm:text-5xl font-semibold tracking-tight text-slate-900 mb-4">{t("services.title")}</h1>
      <p className="text-base md:text-lg text-slate-500 mb-8 max-w-2xl">{t("services.subtitle")}</p>
      <div data-testid="travel-fee-banner" className="flex items-start gap-4 bg-primary/5 border border-primary/20 rounded-2xl p-6 mb-12">
        <span className="inline-flex w-11 h-11 rounded-xl bg-primary/10 items-center justify-center shrink-0">
          <Car className="w-5 h-5 text-primary" />
        </span>
        <div>
          <h3 className="font-heading font-semibold text-slate-900">{t("services.travel_title")}</h3>
          <p className="text-sm text-slate-600 leading-relaxed mt-1">{t("services.travel_note")}</p>
        </div>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {services.map((s) => <ServiceCard key={s.id} service={s} />)}
      </div>
    </div>
  );
}
